import { MEDIA_STUDIO_API_KEY } from '../constants';

const MEDIA_STUDIO_URL = 'https://strategic-honesty-media-studio-production.up.railway.app';

// Normalize platform names to consistent lowercase slugs
// Add new platforms here as needed — one place, fixes everywhere
function normalizePlatform(platform) {
  if (!platform) return 'general';
  const map = {
    'youtube shorts': 'youtube shorts',
    'youtube':        'youtube',
    'tiktok':         'tiktok',
    'instagram':      'instagram',
    'instagram reels': 'instagram',
    'linkedin':       'linkedin',
    'facebook':         'facebook',
    'facebook reels':   'facebook reels',
    'facebook reel':    'facebook reels',
    'instagram reels':  'instagram reels',
    'instagram reel':   'instagram reels',
    'bluesky':        'bluesky',
    'mastodon':       'mastodon',
    'twitter':        'twitter',
    'x':              'twitter',
    'x/twitter':      'twitter',
    'threads':        'threads',
    'pinterest':      'pinterest',
  };
  return map[platform.toLowerCase()] || platform.toLowerCase();
}

export async function sendToMediaStudio({
  schedulerPostId, title, platform, contentType,
  sourceText, imagePrompt, videoPrompt, sceneData, status, source,
}) {
  const payload = {
    schedulerPostId, title, platform: normalizePlatform(platform), contentType,
    sourceText, imagePrompt, videoPrompt,
    sceneData:  sceneData ?? {},
    status:     status    ?? 'pending',
    source:     source    ?? 'scheduler',
  };

  const headers = { 'Content-Type': 'application/json' };
  if (MEDIA_STUDIO_API_KEY) headers['x-api-key'] = MEDIA_STUDIO_API_KEY;

  const res = await fetch(`${MEDIA_STUDIO_URL}/api/queue`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ items: [payload] }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.error || err?.message || `Media Studio error: ${res.status}`);
  }

  return res.json();
}
